import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportOwnData = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 200 200",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0008216,
			d: "M98.667 44.492c-.56-1.013.14 2.312.195 3.467.124 2.62-.258 5.963.58 8.475"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0008216,
			d: "M97.033 43.25c-1.304-.453 2.743.294 4.106.516 2.27.368 6.988 1.577 7.835 4.114 1.975 5.927-7.455 7.024-10.773 8.683M111.989 58.282c-1.085 1.169.766-4.212.837-4.478.963-3.615 1.522-8.443 3.983-10.905 1.053-1.053 1.38 2.652 1.893 4.05 1.195 3.24 1.914 6.536 2.743 9.859M142.249 58.282c-1.085 1.169.766-4.212.837-4.478.963-3.615 1.522-8.443 3.983-10.905 1.053-1.053 1.38 2.652 1.893 4.05 1.195 3.24 1.914 6.536 2.743 9.859"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0008216,
			d: "M112.847 53.214c-1.509-.102 2.593-1.321 2.788-1.369 2.348-.587 5.007-1.306 7.442-1.306M143.107 53.214c-1.509-.102 2.593-1.321 2.788-1.369 2.348-.587 5.007-1.306 7.442-1.306M132.41 43.974c.25-.169.266 3.996.266 4.457 0 2.377-.374 5.412.392 7.706"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0008216,
			d: "M124.133 47.01c-.253-.256 4.589-1.428 4.952-1.517 4.02-1.006 8.09-1.475 12.145-2.285"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M60.98 123.361c-.639-2.352 51.618-2.157 66.18-3.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M61.34 123.82c-.05-.003.297 2.026.341 3.58.107 3.719-.004 7.45-.03 11.168-.045 6.072.075 12.15.513 18.208.066.91-.53 5.822.649 6.695 3.497 2.586 13.066.471 16.948.294 14.987-.686 34.98-.562 48.28-1.92 1.801-.184.005-10.012-.006-11.02-.13-11.48-1.918-19.864-.875-31.328M126.049 119.497c3.399-3.639 8.317-16.73 8.962-19.612"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M138.007 115.125c.394 4.084.748 30.014.748 30.014s-6.278 10.109-10.169 16.706M79.778 104.21c.184-1.112-6.457 4.885-7.226 5.598-5.086 4.715-7.607 8.47-13.227 12.543"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M78.465 103.96c.089-.204 2.788.104 3.012.106 3.656.02 7.317-.272 10.955-.6 13.943-1.25 27.876-3.112 41.866-3.581M76.964 102.334c.591.514-1.3-.872-1.958-1.293-1.163-.744-2.21-1.583-3.255-2.48-3.264-2.797-7.036-5.523-9.866-8.776M40.366 108.456c4.888 5.525 13.777 7.684 18.961 12.972"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M40.362 109.135c2.126-3.317 3.468-2.848 6.396-5.457 5.002-4.453 9.498-9.42 14.53-13.838M135.562 99.486c2.943-.879 19.36-7.615 24.083-10.552"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9930679999999998,
			d: "M159.641 88.934c-5.563 6.557-6.674 10.462-9.657 16.22-.698 1.35-2.226 6.736-3.652 7.509-1.12.609-12.521 3.403-16.117 4.951-.244.107-4.266 1.703-4.17 1.883M77.11 104.186c-.72.002.334 3.49.447 4.659.348 3.6.744 7.064.59 10.687"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0008216,
			d: "M87.676 37.387s1.967 23.394 1.256 26.426c-.713 3.03 52.993 3.394 64.408.224 11.418-3.17.35-23.07 1.748-27.106 1.396-4.038-67.412.456-67.412.456"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			children: [/* @__PURE__ */ _jsx("path", {
				strokeLinejoin: "miter",
				strokeMiterlimit: 10,
				d: "m107.86 109.298-4.936 2.213-3.94-3.703"
			}), /* @__PURE__ */ _jsx("path", { d: "M114.613 76.33s-8.527 17.075-11.689 35.181" })]
		})
	]
});
export default SvgImportOwnData;
